import { default as FlexBar } from './FlexBar';

export default FlexBar;
